/* Volan shared geo engine: resolves the visitor's country once per
   session, then shows the matching [data-geo-variant] inside every
   [data-volan-geo] container on the page.
   Country source (same as the announcement bar): Shopify Markets
   server-side on first paint, refined by IP lookup in the browser.
   Variants: my / id-racket / id-acc / id / row. Product pages resolve
   Indonesia to the racket or accessory variant; everywhere else shows
   every Indonesia variant present. Preview any country with
   ?volan_country=BD. Safe to include multiple times per page
   (deferred, boot-guarded, single lookup chain). */
(function () {
  function parseCode(raw) {
    var m = ((raw || '').trim().toUpperCase().match(/^[A-Z]{2}$/) || [])[0];
    return m || null;
  }

  function resolveKey(code, racket) {
    if (code === 'MY') return 'my';
    if (code === 'ID') {
      if (racket === 'true') return 'id-racket';
      if (racket === 'false') return 'id-acc';
      return 'id';
    }
    if (code) return 'row';
    return null;
  }

  function fallbacksFor(key) {
    if (key === 'my') return ['my', 'row'];
    if (key === 'id') return ['id', 'id-racket', 'id-acc', 'row'];
    if (key === 'id-racket' || key === 'id-acc') return [key, 'id', 'row'];
    return ['row'];
  }

  function firstPresent(present, chain) {
    var out = {};
    for (var i = 0; i < chain.length; i++) {
      if (present[chain[i]]) {
        out[chain[i]] = true;
        break;
      }
    }
    return out;
  }

  function applyBox(box, code) {
    var kids = box.querySelectorAll('[data-geo-variant]');
    if (!kids.length) return;
    var key = resolveKey(code, box.getAttribute('data-volan-is-racket') || '');
    if (!key) return;
    var present = {};
    for (var i = 0; i < kids.length; i++) {
      present[kids[i].getAttribute('data-geo-variant')] = true;
    }
    var show;
    if (key === 'id') {
      // No product in context: show every Indonesia variant present
      // (racket + accessories), so info pages stay complete.
      show = {};
      var idKeys = ['id', 'id-racket', 'id-acc'];
      for (var a = 0; a < idKeys.length; a++) {
        if (present[idKeys[a]]) show[idKeys[a]] = true;
      }
      if (!Object.keys(show).length) show = firstPresent(present, ['row']);
    } else {
      show = firstPresent(present, fallbacksFor(key));
    }
    if (!Object.keys(show).length) return;
    for (var k = 0; k < kids.length; k++) {
      if (show[kids[k].getAttribute('data-geo-variant')]) kids[k].removeAttribute('hidden');
      else kids[k].setAttribute('hidden', '');
    }
    var icons = box.querySelectorAll('[data-geo-icon]');
    if (icons.length) {
      var shownKeys = Object.keys(show);
      var want = shownKeys.length === 1 && shownKeys[0] === 'row' ? 'plane' : 'truck';
      for (var m = 0; m < icons.length; m++) {
        if (icons[m].getAttribute('data-geo-icon') === want) icons[m].removeAttribute('hidden');
        else icons[m].setAttribute('hidden', '');
      }
    }
  }

  function applyAll(code) {
    var boxes = document.querySelectorAll('[data-volan-geo]');
    for (var i = 0; i < boxes.length; i++) {
      var c = code || boxes[i].getAttribute('data-volan-server-country') || '';
      applyBox(boxes[i], c);
    }
  }

  if (window.__volanGeoBooted) {
    applyAll(window.__volanGeoCountry);
    return;
  }
  window.__volanGeoBooted = true;
  window.__volanGeoCountry = null;

  function remember(code) {
    try {
      sessionStorage.setItem('volan_geo_country', code);
    } catch (e) {}
  }

  function tryEndpoint(url, parse) {
    return fetch(url, { mode: 'cors' }).then(function (res) {
      if (!res.ok) throw new Error('geo lookup failed');
      return res.text().then(parse);
    });
  }

  function detect() {
    return tryEndpoint('https://api.country.is/', function (body) {
      try {
        return JSON.parse(body).country || null;
      } catch (e) {
        return null;
      }
    })
      .catch(function () {
        return tryEndpoint('https://ipapi.co/country/', parseCode);
      })
      .catch(function () {
        return tryEndpoint('https://www.cloudflare.com/cdn-cgi/trace', function (body) {
          var m = (body || '').match(/^loc=([A-Za-z]{2})$/m);
          return m ? m[1].toUpperCase() : null;
        });
      })
      .catch(function () {
        return tryEndpoint('https://ipinfo.io/country', parseCode);
      })
      .catch(function () {
        return null;
      });
  }

  try {
    var override = (location.search.match(/[?&]volan_country=([A-Za-z]{2})/) || [])[1];
    if (override) {
      override = override.toUpperCase();
      window.__volanGeoCountry = override;
      remember(override);
      applyAll(override);
      return;
    }
  } catch (e) {}

  var instant = null;
  try {
    instant = sessionStorage.getItem('volan_geo_country');
  } catch (e) {}
  if (parseCode(instant)) {
    window.__volanGeoCountry = instant;
    applyAll(instant);
    return;
  }

  applyAll(null);

  var timedOut = false;
  var timer = setTimeout(function () {
    timedOut = true;
  }, 6000);
  detect().then(function (code) {
    clearTimeout(timer);
    if (timedOut || !parseCode(code)) return;
    window.__volanGeoCountry = code;
    remember(code);
    applyAll(code);
  });
})();
